import axios from "axios";
import {
    authorizationServicesPath,
} from "../../Constants";

const jobRestUrl = authorizationServicesPath + '/customers/organizations/order/assessment'

export default class AssessmentService {
    static async getAll(organizationName) {
        return axios.get(jobRestUrl + "/by-organization-name?organizationName=" + organizationName);
    }

    static async getByOrder(organizationName, id) {
        return axios.get(jobRestUrl + "/by-order?organizationName=" + organizationName + "&id=" + id);
    }

    static async add(data) {
        return await axios.post(jobRestUrl,
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }
}